import { GenericRule } from '../../../../../../../utils/genericValidator.util';
import { AvailabilityEnum } from '../../../../../../products/ProductTypes';
import { OfflineOrderProduct } from '../../OfflineOrderProduct';

export class ValidateGridItemsThatShouldBeEmptyRule implements GenericRule<OfflineOrderProduct> {
  validateOrThrow(orderProduct: OfflineOrderProduct) {
    const gridItemsThatShouldBeEmpty = this.getItemsThatShouldBeEmpty(orderProduct);

    const gridItemsNotEmpty = gridItemsThatShouldBeEmpty.filter(
      (gridItem) => gridItem.quantity > 0,
    );

    if (gridItemsNotEmpty.length > 0) {
      throw new Error('grid items should be empty');
    }
  }

  private getItemsThatShouldBeEmpty(orderProduct: OfflineOrderProduct) {
    switch (orderProduct.availability) {
      case AvailabilityEnum.INFINITE_PRE_ORDER:
      case AvailabilityEnum.MATERIAL_PRE_ORDER:
        return this.getItemsThatShouldBeEmptyToPreOrder(orderProduct);
      case AvailabilityEnum.FUTURE_STOCK:
        return this.getItemsThatShouldBeEmptyToFutureStock(orderProduct);
      case AvailabilityEnum.READY_FOR_DELIVERY:
        return this.getItemsThatShouldBeEmptyToReadyForDelivery(orderProduct);
      case AvailabilityEnum.EMPTY:
        return [];
      default:
        return orderProduct.grid;
    }
  }

  private getItemsThatShouldBeEmptyToPreOrder(orderProduct: OfflineOrderProduct) {
    return orderProduct.grid.filter(
      (gridItem) =>
        orderProduct.deliveryWindow &&
        !gridItem.sku.preOrderDeliveryWindowIds?.includes(orderProduct.deliveryWindow.id),
    );
  }

  private getItemsThatShouldBeEmptyToFutureStock(orderProduct: OfflineOrderProduct) {
    return orderProduct.grid.filter((gridItem) => {
      const { futureStock } = gridItem;
      if (!futureStock) {
        return true;
      }

      const isDifferentColor = futureStock.productColorId !== orderProduct.productColor.id;
      const isDifferentDeliveryWindow = orderProduct.deliveryWindow
        ? futureStock.deliveryWindowId !== orderProduct.deliveryWindow.id
        : false;

      return isDifferentColor || isDifferentDeliveryWindow;
    });
  }

  private getItemsThatShouldBeEmptyToReadyForDelivery(orderProduct: OfflineOrderProduct) {
    return orderProduct.grid.filter((gridItem) => !gridItem.stock);
  }
}
